import { createActions } from 'redux-actions';
export const actions = createActions('CONFIRM_MODAL_SHOW', 'CONFIRM_MODAL_HIDE', 'CONFIRM_MODAL_CONFIRM', 'CONFIRM_MODAL_CANCEL');
